import { render, staticRenderFns } from "./UiCountdownSimple.vue?vue&type=template&id=18e243c1&lang=pug&"
import script from "./UiCountdownSimple.vue?vue&type=script&lang=js&"
export * from "./UiCountdownSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports